import { FeedbackPromptResponseDetails } from "./EmployeeFeedbackModel";
//EMNJDOJA28DREMINDERModel  Prompt -> On submission records get pushed to Strand.
export class EMNJDOJA28DREMINDERModel {
    EnterpriseId!: string;
    CardUniqueId!: string;
    FeedbackPromptComments!:string[];
    CategoryType!: string;    ChannelType!: string;
    FeedbackPromptResponseDetails !: FeedbackPromptResponseDetails[];
    IsPostAnonymous !: boolean;
}